import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GatesMonitorDto } from '../../../../data/models/dto/arrival/gates-monitor.dto';
import { ArrivalStatus } from '../../../../data/models/enum/arrival/arrival-status.enum';
import { Vehicle } from '../../../../data/models/enum/arrival/vehicle.enum';
import { SimpleLogSheetComponent } from '../../simple-log-sheet/simple-log-sheet.component';

@Component({
  selector: 'app-card-arrival-history',
  templateUrl: './card-arrival-history.component.html',
  styleUrls: ['./card-arrival-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardArrivalHistoryComponent implements OnInit {
  @Input()
  gatesMonitor!: GatesMonitorDto;
  mobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  isMobile() {
    if (window.screen.width < 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  constructor(
    private _bottomSheet: MatBottomSheet,
    private elRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    let cardScreenMobile =
      this.elRef.nativeElement.children[0].children[0].getElementsByClassName(
        'accordion'
      );
    let elementAccordion =
      this.elRef.nativeElement.children[0].children[0].children[0];
    let i;

    for (i = 0; i < cardScreenMobile.length; i++) {
      cardScreenMobile[i].addEventListener('click', () => {
        elementAccordion.children[0].classList.toggle('rotate');
        elementAccordion.classList.toggle('active');
        let panelClass = elementAccordion.nextElementSibling;

        if (panelClass.style.maxHeight) {
          panelClass.style.maxHeight = null;
        } else {
          panelClass.style.maxHeight = '100%';
        }
      });
    }
  }

  ngOnInit(): void {
    this.isMobile();
  }

  get classRoomDescription(): string {
    return this.gatesMonitor?.child.segment.name
      .concat(' - ')
      .concat(this.gatesMonitor?.child.classRoom.name)
      .concat(' ')
      .concat(this.gatesMonitor?.child.serie.name);
  }

  get iconVehicle(): string {
    const icon = this.gatesMonitor?.vehicle;
    switch (icon) {
      case Vehicle.FOOT:
        return 'directions_run';
      case Vehicle.CAR:
        return 'directions_car';
      case Vehicle.BICYCLE:
        return 'directions_bike';
      default:
        //quando Vehicle.MOTORCYCLE:
        return 'two_wheeler';
    }
  }

  openBottomSheet(event: any) {
    if (event.path && event.path[0].className.includes('btn-arrow')) {
      return;
    } else if (this.gatesMonitor.status === ArrivalStatus.CANCELED) {
      this._bottomSheet.open(SimpleLogSheetComponent, {
        data: this.gatesMonitor.history.filter(
          (log) => log.status === ArrivalStatus.CANCELED
        ),
        panelClass: ['custom-bottom-sheet-container'],
      });
    }
  }
}
